<template>
  <div class="pnel_top_section pnel_lightBg py-3" v-if="showCityFilter || showCuisinesFilter">
    <div class="d-flex align-center justify-space-between py-3 flex-column flex-md-row pnel-location-filter mx-auto">
      <div class="d-flex align-center w-100 flex-column flex-sm-row pnel_custom_autocomplete">
        <v-combobox class="px-3 pnel_auto-complete mt-3 mt-sm-0" v-model="selectCity" :items="cities" item-value="title"
          item-text="title" @click="updateActiveScroll" @keydown.enter="invalidSearch"
          @keydown.down.prevent="navigateDown" @keydown.up.prevent="navigateUp" ref="cityCombobox" v-if="showCityFilter"
          cache-items :menu-props="{
    closeOnContentClick: true,
  }" label="Stadt,PLZ oder lokal ...">
          <template v-slot:item="props">
            <div class="py-3 px-3 d-flex justify-space-between pnel_combobox" @click="handleItemClick(props)"
              :class="{ activeClass: props.index === activeIndex }">
              <span class="pr-2 text-no-wrap custom-text-wrap">{{
    props.item.title
  }}</span>
              <span>{{ props.item.raw.type }}</span>
            </div>
          </template>
        </v-combobox>
        <v-btn class="pnel_reset_btn px-5 mt-3 mt-md-0 mr-2" v-if="!showCuisinesFilter" @click="resetFilters">Reset
          Filter</v-btn>
      </div>
    </div>
    <div class="d-flex align-center justify-space-between flex-column flex-md-row pnel_filters px-4"
      v-if="showCuisinesFilter">
      <div class="d-flex align-center flex-column flex-sm-row pnel_custom_autocomplete">
        <div
          class="d-flex align-center w-100 justify-space-between flex-column flex-md-row pnel_filters pnel_cuisine_filters whitespace-wrap">
          <div
            class="d-flex align-center  w-100 justify-space-between flex-column flex-md-row pnel_filters pnel_cuisine_filters whitespace-wrap">
            <v-slide-group v-model="cuisineItems" class="w-100" multiple show-arrows>
              <v-slide-group-item v-for="item in cuisineItems" :key="item">
                <div class="pnel-cuisine d-flex flex-column justify-content-center align-items-center px-5 icon"
                  @click="toggleSelection(item)" :class="{ 'selected': item.selected }">
                  <v-img v-if="getIconUrl(item.slug)" :src="getIconUrl(item.slug)" :width="40" :height="50"
                    :alt="item.name"></v-img>
                  <v-img v-else :src="restaurantIcon" :width="40" :height="50" :alt="item.name"></v-img>
                  <v-list-item-title v-html="item.name"></v-list-item-title>
                </div>
              </v-slide-group-item>
            </v-slide-group>
          </div>
          <v-autocomplete class="px-3 pnel_auto-complete pnel_auto_scroll d-none" multiple label="Wählen Sie Küche"
            v-model="selectCuisine" :menu-props="{ closeOnContentClick: true }" :items="cuisineItems" item-text="name"
            item-value="slug">
          </v-autocomplete>
        </div>
      </div>
      <v-btn class="pnel_reset_btn px-5 mt-3 mt-md-0 mr-2" v-if="showCityFilter || showCuisinesFilter"
        @click="resetFilters">Reset Filter</v-btn>
    </div>
  </div>
  <div class="d-flex pnel_mainscroll pnel_lightBg position-relative" ref="infoBox">
    <div class="flex-1-1-100 pnel_list h-100 overflow-auto" id="pnel-infinite-list"
      :class="(isMobile && viewTypeMob == 'map') || (!isMobile && viewType == 'map') ? 'd-none' : ''">
      <div class="v-col-12">
        <div class="v-row h-100" v-if="renderComponent">
          <div v-if="loading" v-for="data in 9" :key="data"
            class="v-col-sm-6 v-col-lg-4 v-col-12 d-flex flex-col pnel_custom_width">
            <v-card class="position-relative w-100 pnel_loading_animation">
              <img class="w-100 pnel_custom_image_width pnel_loading_animation" alt="restaurant" src="" />
              <div class="pnel_city_restaurant py-1 px-2 position-absolute rounded-lg pnel_loading_animation"></div>
              <div class="position-absolute bottom-0 pt-11 px-3 pb-4 w-100 pnel_object_info">
                <v-card-title class="pa-0 text-truncate pnel_loading_animation"></v-card-title>
                <v-card-text class="pa-0 text-truncate pnel_loading_animation"></v-card-text>
                <v-card-text class="pa-0 text-truncate pnel_loading_animation"></v-card-text>
              </div>
            </v-card>
          </div>
          <div v-else class="v-col-sm-6 v-col-lg-4 v-col-12 d-flex flex-col" v-for="(data, index) in mapsItems"
            :key="index">
            <v-card class="position-relative w-100" @click="loadPartnerOverlayFunc(data.product.ID)">
              <img v-if="data.product.image_url" class="w-100 pnel_custom_image_width" alt="restaurant"
                :src="data.product.image_url[0]" />
              <img v-else class="w-100 pnel_custom_image_width" alt="restaurant" :src="defaultResturantImage" />
              <div class="pnel_city_restaurant py-1 px-2 position-absolute rounded-lg" v-if="data.childCount">
                {{ data.childCount }} locations
              </div>
              <div class="pnel_city_restaurant py-1 px-2 position-absolute rounded-lg" v-else>
                {{
    data.product.meta_data.find((itm) => itm.key == "ort")
      ? data.product.meta_data.find((itm) => itm.key == "ort")
        .value
      : ""
  }}
              </div>
              <div class="pnel_distance py-1 px-2 position-absolute rounded-lg" v-if="data.product.radius">
                {{ data.product.radius.toFixed(2) }} Km.
              </div>
              <div class="position-absolute bottom-0 pt-11 px-3 pb-4 w-100 pnel_object_info">
                <div v-if="data.product.name" class="v-card-title pa-0">
                  <p v-html="data.product.name"></p>
                </div>
                <div v-if="data.product.cuisine" class="v-card-text pa-0">
                  <p v-html="data.product.cuisine"></p>
                </div>

              </div>
            </v-card>
          </div>
        </div>
        <div v-if="!loading && !mapsItems.length" class="mt-5">
          <div class="text-h3 font-weight-bold text-orange-darken-4">
            No exact matches
          </div>
          <div class="text-orange-darken-4 mb-2">
            Try changing or removing some of your filters or adjusting your search area.
          </div>
          <div>
            <v-btn v-if="viewType == 'split'" @click="getOuterLocationsData()">
              Show nearest results
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <div class="flex-1-1-100 pnel_map position-relative px-3" v-if="renderComponentSecond"
      :class="(isMobile && viewTypeMob == 'list') || (!isMobile && viewType == 'list') ? 'd-none' : ''">
      <div class="position-absolute d-flex w-100 h-100 top-0 left-0 align-center justify-center pnel_custom_loader"
        v-if="loading">
        <div class="pnel_city_restaurant py-2 px-3 position-absolute rounded-lg pnel_loading_animation_error"
          v-if="errormessage">{{ this.errormessage }}</div>
        <div class="pnel_loader"></div>
      </div>
      <div id="map" style="width: 100%; height: 100%"></div>
    </div>
    <div class="pnel_switch_btn_main w-100 text-center"
      :class="viewType == 'split' && (viewTypeMobData == 'map|list' || viewTypeMobData == 'list|map') ? 'd-block d-md-none' : 'd-none'">
      <v-btn class="pnel_reset_btn px-5 mt-3 mt-md-0 pnel_view_btn" @click="updateView(!view)">Map View</v-btn>
    </div>
  </div>
</template>

<script>
import plzjson from "./../assets/plz_koordinaten_array2.json";
import cuisineJson from "./../assets/cuisine.json";
import cityJson from "./../assets/city.json";
import axios from "axios";
import customIcon from "@/assets/icon2.png";
import circleClusterIcon from "@/assets/circle.png";
import config from "./../assets/config.json";
import barDrinkIcon from "@/assets/bonbon_bar.png";
import cafeBakeryIcon from "@/assets/bonbon_cafe.png";
import restaurantIcon from "@/assets/bonbon_restaurant.png";

export default {
  data() {
    return {
      map: null,
      apiKey: config.googleMapsApiKey,
      cityJson: cityJson,
      loading: false,
      mapsItems: [],
      renderComponent: true,
      renderComponentSecond: true,
      selectCuisine: [],
      selectCity: null,
      ignoreCity: false,
      zoomChanged: false,
      showCityFilter: false,
      showCuisinesFilter: false,
      cities: [],
      names: [],
      cuisineItems: [],
      cuisineJson: cuisineJson,
      view: false,
      switchView: false,
      viewButtonClicked: false,
      forceUpdateView: true,
      mapsData: [],
      zoom: config.defaultZoom,
      markers: [],
      markerCluster: null,
      plzjson: plzjson,
      infoWindow: null,
      defaultResturantImage: '',
      setCenterLocation: {},
      testZoom: 0,
      outerLocations: false,
      activeIndex: -1,
      ro: null,
      windowDivWidth: null,
      divHeight: null,
      searchRadius: config.setupRadius,
      searchZoom: 0,
      activeClass: "pnel-active-item",
      getApiForFiltersData: "",
      getApiForJsonData: "",
      getApiForTitle: "",
      isMapDragging: false,
      errormessage: "",
      centerNeLat: "",
      centerSwLat: "",
      centerNeLng: "",
      centerSwLat: "",
      outerRadius: config.defaultRadius,
      barDrinkIcon: barDrinkIcon,
      customIcon: customIcon,
      cafeBakeryIcon: cafeBakeryIcon,
      restaurantIcon: restaurantIcon,
      zoomByShortcode: null,
      viewType: 'split',
      viewTypeMob: null,
      viewTypeMobData: null,
      isMobile:false,
      context: null,
      locationFilter: null,
      cuisineIcons: []
    };
  },
  created() {
    this.center = {
      lat: parseFloat(config.centerLat),
      lng: parseFloat(config.centerLng),
      label: config.centerLabel,
    };
    this.zoom = config.defaultZoom;
  },
  methods: {
    toggleSelection(item) {
      item.selected = !item.selected; // Toggle the 'selected' property

      if (this.selectCuisine.includes(item.slug)) {
        const index = this.selectCuisine.indexOf(item.slug);
        this.selectCuisine.splice(index, 1);
      } else {
        this.selectCuisine.push(item.slug);
      }

      // Check if the viewType is not 'list' and then perform actions
      if (this.viewType !== 'list') {
        this.getCurrentBounds();
      }
      this.forceUpdateView = false;
      this.getAllApiDataByFilter(config.defaultRadius);
      this.forceRerender();
      this.forceRerenderSecond();
    },
    getOuterLocationsData() {
      this.selectCity = null;
      this.locationFilter = null;
      this.forceUpdateView = false;
      this.outerLocations = true;
      // if(this.viewType != 'list'){
      //   this.getCurrentBounds();
      // }
      this.getAllApiDataByFilter(config.defaultRadius);
      this.forceRerender();
      this.forceRerenderSecond();
    },
    getIconUrl(name) {
      const restaurantIcons = this.cuisineIcons;

      // Return the SVG icon URL based on the cuisine name
      return restaurantIcons[name]; // Provide a default icon if not found
    },
    // Function to calculate NE and SW bounds with 50km radius
    calculateBounds(latitude, longitude, radius) {
      const lat = latitude;
      const lon = longitude;
      const distance = radius;

      // One degree of latitude is approximately 111 kilometers
      const latDelta = distance / 111;
      // One degree of longitude varies based on latitude
      const lonDelta = distance / (111 * Math.cos(lat * (Math.PI / 180)));

      // Calculate bounding box coordinates
      const north = lat + latDelta;
      const south = lat - latDelta;
      const east = lon + lonDelta;
      const west = lon - lonDelta;

      return { north, south, east, west };
    },
    // Default center bounds from config
    defaultCenterNeswBounds() {
      this.centerNeLat = config.centerNeLat;
      this.centerSwLat = config.centerSwLat;
      this.centerNeLng = config.centerNeLng;
      this.centerSwLng = config.centerSwLng;
    },
    // Get current center bounds after map init
    getCurrentBounds() {
      let getCenterBounds = this.map.getBounds();
      this.centerNeLat = getCenterBounds.getNorthEast().lat();
      this.centerSwLat = getCenterBounds.getSouthWest().lat();
      this.centerNeLng = getCenterBounds.getNorthEast().lng();
      this.centerSwLng = getCenterBounds.getSouthWest().lng();
    },
    updateActiveScroll() {
      // Reset the active index to -1
      this.activeIndex = -1;
      // Check if the 'cities' array is not empty
      if (this.cities.length) {
        // Clear the selected city
        this.selectCity = "";
        this.locationFilter = "";
        // Find the DOM element with the 'active-item' class
        const item = document.querySelector(`.${this.activeClass}`);
        // If an 'active-item' element is found
        if (item) {
          // Find the parent element of the 'active-item' and reset its scrollTop to 0
          const parent = item.parentElement;
          parent.scrollTop = 0;
        }
      }
    },
    navigateDown() {
      // Check if there are more cities below the current active index
      if (this.activeIndex < this.cities.length - 1) {
        // Increment the active index
        this.activeIndex++;
        // Set 'selectCity' to the title of the currently active city
        this.selectCity = this.cities[this.activeIndex].title;

        // Find the DOM element with the 'active-item' class
        const item = document.querySelector(`.${this.activeClass}`);
        // If an 'active-item' element is found and the active index is a multiple of 5
        if (item && this.activeIndex % 5 == 0) {
          // Find the parent element of the 'active-item' and scroll to the top of the 'active-item'
          const parent = item.parentElement;
          parent.scrollTop = item.offsetTop;
        }
      }
    },
    navigateUp() {
      // Check if there are more cities above the current active index
      if (this.activeIndex > 0) {
        // Decrement the active index
        this.activeIndex--;
        // Set 'selectCity' to the title of the currently active city
        this.selectCity = this.cities[this.activeIndex].title;

        // Find the DOM element with the 'active-item' class
        const item = document.querySelector(`.${this.activeClass}`);
        // If an 'active-item' element is found and the active index is a multiple of 5
        if (item && this.activeIndex % 5 == 0) {
          // Find the parent element of the 'active-item' and scroll to the top of the 'active-item'
          const parent = item.parentElement;
          parent.scrollTop = item.offsetTop;
        }
      }
    },
    // Function to handle invalid search input
    invalidSearch(e) {
      // Blur the focus from the cityCombobox input
      this.$refs.cityCombobox.blur();

      // Find an item in the 'cities' array that matches the search input (case-insensitive)
      const itemFound = this.cities.find((item) => {
        if (item.title.toLowerCase() == e.target.value.toLowerCase()) {
          this.selectCity = item.title;
          this.getCurrentBounds();
          this.forceRerender();
          this.forceRerenderSecond();
          return true;
        }
      });
      // If no matching item was found, reset the map and related data
      if (itemFound == undefined) {
        this.center = {
          lat: parseFloat(config.centerLat),
          lng: parseFloat(config.centerLng),
          label: config.centerLabel,
        };
        this.zoom = config.defaultZoom;
        const newCenter = new google.maps.LatLng(config.centerLat, config.centerLng); // Replace with your new coordinates
        // Set the new center and zoom
        this.map.setCenter(newCenter);
        this.map.setZoom(this.zoom);
      }
    },
    // Function to filter data by selected city
    handleItemClick(props) {
      this.locationFilter = "";
      // Blur the active element to remove focus
      const activeElement = document.activeElement;
      if (activeElement instanceof HTMLElement) {
        activeElement.blur();
      }
      // Reset the search radius and scroll to the top of the list
      this.searchRadius = 0;
      const listElm = document.querySelector("#pnel-infinite-list");
      listElm.scrollTop = 0;
      // Update the selected item based on the clicked item
      this.selectCity = props.item.title;
      this.zoomChanged = false;
      var zoom = config.defaultZoom;
      lat = config.centerLat;
      lng = config.centerLng;

      // Handle different cases based on the selected city
      if (this.selectCity !== "" && this.selectCity !== null && this.ignoreCity === false) {
        // Check if the selected city is a number (e.g., postal code)
        if (!isNaN(parseInt(this.selectCity))) {
          //pnel - active;
          // Find the center coordinates for the selected postal code
          Object.entries(this.plzjson).find(([key, item]) => {
            if (key == this.selectCity) {
              lat = parseFloat(item[2]);
              lng = parseFloat(item[1]);
              zoom = config.defaultZipcodeZoom;
            }
          });
        } else {
          // Find coordinates for the selected city
          if (
            Object.keys(this.setCenterLocation).length === 0 ||
            this.selectCity.toLowerCase() !== this.center.label.toLowerCase()
          ) {
            var lat = 0;
            var lng = 0;
            this.cityJson.find((item) => {
              if (item.city == this.selectCity) {
                lat = parseFloat(item.lat);
                lng = parseFloat(item.lng);
              }
            });
            if (!lat || !lng) {
              Object.entries(this.plzjson).find(([key, item]) => {
                if (item[0] == this.selectCity) {
                  lat = parseFloat(item[2]);
                  lng = parseFloat(item[1]);
                }
              });
            }
            zoom = config.defaultCityZoom;
          }
        }
        this.forceUpdateView = false;
        if (this.viewType != 'list') {
          const newCenter = new google.maps.LatLng(lat, lng); // Replace with your new coordinates
          const newZoom = zoom; // Replace with your new zoom level
          // Set the new center and zoom
          this.map.setCenter(newCenter);
          this.map.setZoom(newZoom);
          if (this.outerLocations) {
            this.getAllApiDataByFilter(0, false);
          }
        } else {
          this.getAllApiDataByFilter(0, true);
        }
      }

      this.forceRerender();
      this.forceRerenderSecond();
    },
    // Function to extract latitude and longitude from data
    getLatLng(data) {
      let result = {};
      // Find latitude and longitude in the data, if available
      let lat = data.find((itm) => itm.key == "latitude")
        ? data.find((itm) => itm.key == "latitude").value
        : "";
      let lng = data.find((itm) => itm.key == "longitude")
        ? data.find((itm) => itm.key == "longitude").value
        : "";
      // If both latitude and longitude are available, parse them into floats
      if (lat && lng) {
        result.lat = parseFloat(lat);
        result.lng = parseFloat(lng);
      } else {
        result.lat = null;
        result.lng = null;
      }
      return result;
    },
    calculateZoomLevel(neBound, swBound, mapWidth, mapHeight, bufferFactor) {
      if (
        isNaN(neBound.lat) ||
        isNaN(neBound.lng) ||
        isNaN(swBound.lat) ||
        isNaN(swBound.lng) ||
        isNaN(mapWidth) ||
        isNaN(mapHeight) ||
        isNaN(bufferFactor) ||
        bufferFactor < 0
      ) {
        // Handle invalid input values or buffer factor here
        return 0; // Or any other suitable default value
      }
      const WORLD_DIM = { height: 256, width: 256 };
      const ZOOM_MAX = 14; // Maximum zoom level

      const latFraction = (neBound.lat - swBound.lat) / 360;
      const lngFraction = (neBound.lng - swBound.lng) / 360;

      const latZoom = Math.log(mapHeight / WORLD_DIM.height / latFraction) / Math.LN2;
      const lngZoom = Math.log(mapWidth / WORLD_DIM.width / lngFraction) / Math.LN2;

      // Take the smaller of the two zoom levels, considering bufferFactor
      const zoomLevel = Math.min(latZoom, lngZoom) - bufferFactor;

      // Ensure that the zoom level is within a reasonable range
      return Math.min(Math.max(0, Math.floor(zoomLevel)), ZOOM_MAX);
    },
    // Asynchronous function to fetch API data
    async getCuisinesApiData() {
      try {
        await axios.get(this.getCuisinesList, {}).then((response) => {
          this.cuisineItems = Object.values(response.data);
          this.cuisineItems = this.cuisineItems.map((item) => {
            if (this.selectCuisine.includes(item.slug)) {
              return {
                name: item.name,
                slug: item.slug,
                selected: true
              };

            } else {
              return {
                name: item.name,
                slug: item.slug,
                selected: false
              };
            }
          });
        })
          .catch((error) => {
            if (error) {
              this.errormessage = error.message;
            }
          });
      } catch (e) {
        console.log(e);
      }
    },
    // Asynchronous function to fetch API data
    async getLocationsApiData() {
      try {
        let plz = {};
        // Fetch map data using Axios
        await axios.get(this.getApiForJsonData, {})
          .then((response) => {
            // Extract and format city data
            this.cities = response.data.cities.map((item) => {
              let data = {};
              data.title = item.title;
              data.type = "city";
              return data;
            });
            // Extract and format restaurant names
            this.names = response.data.posts.map((item) => {
              let data = {};
              data.title = item.title;
              data.type = "restaurant";
              return data;
            });
            // Extract and format postal code (PLZ) data
            plz = Object.entries(this.plzjson).map(([key, item]) => {
              let data = {};
              data.title = key;
              data.type = item[0];
              return data;
            });
            // Combine city, restaurant, and postal code data
            this.cities = this.cities.concat(this.names);
            this.cities = this.cities.concat(plz);
          });
      } catch (e) {
        console.log(e);
      }
    },
    // Function to fetch and display API data filtered by selected options
    async getAllApiDataByFilter(updateRadius = 0, updateBounds = false) {
      try {
        // Reset mapsData and set loading state to true
        this.mapsData = [];
        this.loading = true;
        // Initialize the parameters object for the API request
        let params = {};

        //change filter to default when no latlong found
        if (this.center.lat === 0 && this.center.lng === 0) {
          this.center.lat = config.centerLat;
          this.center.lng = config.centerLng;
        }

        if ((this.centerNeLat == null || this.centerNeLat == "") && (this.centerSwLat == null || this.centerSwLat == "") && (this.centerNeLng == null || this.centerNeLng == "") && (this.centerSwLng == null || this.centerSwLng == "")) {
          this.defaultCenterNeswBounds();
        }
        else if (this.centerNeLat <= 0 || this.centerSwLat <= 0 || this.centerNeLng <= 0 || this.centerSwLng <= 0) {
          this.defaultCenterNeswBounds();
        }

        // Handle different cases based on the selected city
        if (this.selectCity !== "" && this.selectCity !== null && this.ignoreCity === false) {
          // Check if the selected city is a number (e.g., postal code)
          if (!isNaN(parseInt(this.selectCity))) {
            params.plz = this.selectCity;
          } else {
            // Find coordinates for the selected city
            params.city = this.selectCity;
          }
        }

        // Handle different cases based on the selected location in shortcode
        if (((this.locationFilter !== "" && this.locationFilter !== null) || updateBounds) && this.ignoreCity === false) {
          if (updateBounds) {
            this.locationFilter = this.selectCity
          }

          var lat = 0;
          var lng = 0;
          // Check if the selected city is a number (e.g., postal code)
          if (!isNaN(parseInt(this.locationFilter))) {
            // Check if the selected city is a number (e.g., postal code)
            Object.entries(this.plzjson).find(([key, item]) => {
              if (key == this.locationFilter) {
                lat = parseFloat(item[2]);
                lng = parseFloat(item[1]);
              }
            });
            if (lat && lng) {
              this.zoom = config.defaultZipcodeZoom;
              const { north, south, east, west } = this.calculateBounds(lat, lng, '2');
              // Set bounds by filtered location from shortcode
              this.center.lat = lat;
              this.center.lng = lng;
              this.centerNeLat = north;
              this.centerNeLng = east;
              this.centerSwLat = south;
              this.centerSwLng = west;
            }
          } else {
            this.cityJson.find((item) => {
              if (item.city == this.locationFilter) {
                lat = parseFloat(item.lat);
                lng = parseFloat(item.lng);
              }
            });
            if (!lat || !lng) {
              Object.entries(this.plzjson).find(([key, item]) => {
                if (item[0] == this.locationFilter) {
                  lat = parseFloat(item[2]);
                  lng = parseFloat(item[1]);
                }
              });
            }
            if (lat && lng) {
              this.zoom = config.defaultCityZoom;
              const { north, south, east, west } = this.calculateBounds(lat, lng, '19');
              // Set bounds by filtered location from shortcode
              this.center.lat = lat;
              this.center.lng = lng;
              this.centerNeLat = north;
              this.centerNeLng = east;
              this.centerSwLat = south;
              this.centerSwLng = west;
            }
          }
        }
        params.zoom = this.zoom;
        params.lat = this.center.lat;
        params.lng = this.center.lng;
        params.nelat = this.centerNeLat;
        params.nelng = this.centerNeLng;
        params.swlat = this.centerSwLat;
        params.swlng = this.centerSwLng;
        params.radius = updateRadius;
        // Add additional parameters based on other user selections
        if (this.selectCuisine.length) {
          params.cuisine = this.selectCuisine;
        }
        if (this.outerLocations) {
          params.outerLocation = this.outerLocations;
        }
        // Fetch data from the API based on the parameters
        let mapsData = await axios.get(this.getApiForFiltersData, {
          params: params,
        }).then((response) => {

          if (this.outerLocations) {
            if (response.data.bounds && response.data.bounds.neLat && response.data.bounds.swLat) {
              const neLat = response.data.bounds.neLat;
              const neLng = response.data.bounds.neLng;
              const swLat = response.data.bounds.swLat;
              const swLng = response.data.bounds.swLng;

              // Calculate the center point
              const centerLat = (neLat + swLat) / 2;
              const centerLng = (neLng + swLng) / 2;

              // Update the center data
              this.center = {
                lat: centerLat,
                lng: centerLng,
                label: config.centerLabel
              };
              let calculatedZoomLevel = this.calculateZoomLevel({ 'lat': neLat, 'lng': neLng }, { 'lat': swLat, 'lng': swLng }, this.$refs.infoBox.clientWidth, this.$refs.infoBox.clientHeight, 0);
              this.zoom = calculatedZoomLevel - 1;
              this.centerNeLat = neLat;
              this.centerNeLng = neLng;
              this.centerSwLat = swLat;
              this.centerSwLng = swLng;
            }
          }

          // Process and filter the fetched data
          this.mapsData = response.data.data
            .map((itm) => {
              if (!parseInt(this.selectCity) || this.selectCity == null) {
                itm.radius = 0;
              }
              let result = this.getLatLng(itm.product.meta_data);
              if (itm.product.child.length) {
                itm.product["childData"] = itm.product.child
                  .map((data) => {
                    let latlng = this.getLatLng(data.meta_data);
                    if (latlng.lat && latlng.lng) {
                      data["position"] = latlng;
                      return data;
                    }
                  })
                  .filter((value) => value);
              }
              if (result.lat && result.lng) {
                itm["position"] = result;
                return itm;
              } else {
                return itm;
              }
            })
            .filter((value) => value);
          // Sort the map items based on priority
          this.mapsItems = this.mapsData;
          if (params.plz) {
            this.mapsItems.sort((a, b) => {
              const firstRadius = parseFloat(a.product.radius) || 0;
              const secondRadius = parseFloat(b.product.radius) || 0;
              return firstRadius - secondRadius;
            });
          } else {
            this.mapsItems.sort((a, b) => {
              const first =
                a.product.meta_data.find((itm) => itm.key == "priority")?.value ??
                0;
              const second =
                b.product.meta_data.find((itm) => itm.key == "priority")?.value ??
                0;
              return parseInt(second) - parseInt(first);
            });
          }


          // Load Google Maps and initialize the map if not already loaded
          if (!window.google || !window.google.maps) {
            this.zoom = this.zoomByShortcode ? parseInt(this.zoomByShortcode) : this.zoom;
            this.loadGoogleMaps()
              .then(() => {
                this.initMap();
                this.loading = false;
                this.isMapDragging = false;
                this.zoomChanged = false;
              })
              .catch((error) => {
                console.error("Error loading Google Maps:", error);
              });
          } else {
            this.initMap(); // Your map initialization code
            this.isMapDragging = false;
            this.zoomChanged = false;
            // Additional logic for view and map bounds check
            if (!this.view && this.forceUpdateView && parseFloat(this.windowDivWidth) <= 959.98) {
              this.isMobile = true;
              this.updateView(true);
            }
            if (this.viewType != 'list') {
              setTimeout(this.checkMapBounds, 1000);
            } else {
              this.loading = false;
            }
            this.outerLocations = false;
          }
        })
          .catch((error) => {
            if (error) {
              this.errormessage = error.message;
            }
          });
      } catch (e) {
        console.log(e);
      }
    },

    // Function to asynchronously load the Google Maps JavaScript API
    async loadGoogleMaps() {
      return new Promise((resolve, reject) => {
        // Create a script element for loading the Google Maps API
        const script = document.createElement("script");
        // Set the source URL for the Google Maps API script
        script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&libraries=geometry,marker&callback=initGoogleMap`;
        // Handle script loading errors by rejecting the promise
        script.onerror = reject;
        // Append the script element to the <head> of the HTML document
        document.head.appendChild(script);
        // Set up a global callback function 'initGoogleMap' to be called when the script is successfully loaded, resolving the promise
        window.initGoogleMap = resolve;
      });
    },
    // Function to initialize the Google Map
    async initMap() {
      // Create a new Google Map instance and set its center and zoom level
      this.map = new google.maps.Map(document.getElementById("map"), {
        center: this.center, // Center coordinates
        zoom: this.zoom, // Zoom level
        maxZoom: 17,
        minZoom: 9,
        fullscreenControl: false,
      });

      // Define a custom map style
      const mapStyle = [
        {
          featureType: "poi",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "road",
          stylers: [
            {
              color: "#ededed",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#999999",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "labels.text.stroke",
          stylers: [
            {
              color: "#ffffff",
            },
          ],
        },
        {
          featureType: "water",
          stylers: [
            {
              color: "#e4eef2",
            },
          ],
        },
        {
          featureType: "transit",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "administrative.country",
          elementType: "geometry.stroke",
          stylers: [
            {
              color: "#bcbcbc",
            },
          ],
        },
        {
          featureType: "landscape",
          stylers: [
            {
              color: "#f8f8f8",
            },
          ],
        },
      ];

      // Apply the custom map style to the map
      this.map.setOptions({ styles: mapStyle, scrollwheel: false });
      // Initialize markers and MarkerClusterer
      this.markers = [];
      this.markerCluster = new MarkerClusterer(this.map, [], {
        imagePath: "", // Path to marker cluster images
        styles: [
          {
            url: circleClusterIcon, // Custom icon for cluster size 1
            width: 50, // Width of the custom icon
            height: 50, // Height of the custom icon
            textColor: "#72c8d9", // Text color (if you want to display a cluster label)
            textSize: 18, // Text size (if you want to display a cluster label)
            backgroundPosition: "center", // Center the text
            backgroundSize: "cover",
          },
        ],
      });
      var count = 0;
      var barString = "Bar";
      var cafeString = "Café";
      var restaurantString = "Restaurant";
      // Loop through each location in mapsItems to create markers
      this.mapsItems.forEach((location) => {
        if (location.product.childData !== undefined) {
          count += 1;
          // Loop through childData for sub-markers
          location.product.childData.forEach((item) => {
            if (
              (location.position == undefined && item.position !== undefined) ||
              location.position.lat !== item.position.lat
            ) {
              // Create a sub-marker for the item

              // Cuisine icons
              let markerIcon = this.customIcon;
              var actualString = location?.product?.category.split(",");

              if (actualString?.includes(restaurantString)) {
                markerIcon = this.restaurantIcon;
              } else if (actualString?.includes(barString)) {
                markerIcon = this.barDrinkIcon;
              } else if (actualString?.includes(cafeString)) {
                markerIcon = this.cafeBakeryIcon;
              } else {
                markerIcon = this.customIcon;
              }

              let marker = ''
              // Check if item type is restaurant
              if (actualString?.includes(restaurantString)) {
                // Create a marker for the location
                marker = this.addMarkersOnMap(
                  item.position.lat,
                  item.position.lng,
                  this.decodeHtmlEntities(location.product.name),
                  markerIcon,
                  item.slug,
                  true
                );
              }
              else {
                // Create a marker for the location
                marker = this.addMarkersOnMap(
                  item.position.lat,
                  item.position.lng,
                  this.decodeHtmlEntities(location.product.name),
                  markerIcon,
                  item.slug
                );
              }
              let partner = location.product.ID

              // Add event listeners for marker interactions
              marker.addListener("click", () => {
                loadPartnerOverlay(partner, this.context);
              });

              this.markers.push(marker); // Add the marker to the markers array
            }
          });
          location.childCount = location.product.childData.length; // Set childCount property
        }
        else {
          if (location.position !== undefined) {

            // Cuisine icons
            let markerIcon = this.customIcon;

            var actualString = location?.product?.category.split(",");

            if (actualString?.includes(restaurantString)) {
              markerIcon = this.restaurantIcon;
            } else if (actualString?.includes(barString)) {
              markerIcon = this.barDrinkIcon;
            } else if (actualString?.includes(cafeString)) {
              markerIcon = this.cafeBakeryIcon;
            } else {
              markerIcon = this.customIcon;
            }
            let marker = ''
            // Check if item type is restaurant
            if (actualString?.includes(restaurantString)) {
              // Create a marker for the location
              marker = this.addMarkersOnMap(
                location.position.lat,
                location.position.lng,
                this.decodeHtmlEntities(location.product.name),
                markerIcon,
                location.slug,
                true
              );
            }
            else {
              // Create a marker for the location
              marker = this.addMarkersOnMap(
                location.position.lat,
                location.position.lng,
                this.decodeHtmlEntities(location.product.name),
                markerIcon,
                location.slug
              );

            }
            let partner = location.product.ID

            // Add event listeners for marker interactions
            marker.addListener("click", () => {
              loadPartnerOverlay(partner, this.context);
            });

            this.markers.push(marker); // Add the marker to the markers array
          }
        }
      });
      // Clear and update the MarkerClusterer with the created markers
      this.markerCluster.clearMarkers();
      this.markerCluster.addMarkers(this.markers);

      // Add event listeners for map events
      // this.map.addListener("center_changed", this.getCurrentZoom);
      this.map.addListener("zoom_changed", this.getCurrentZoom);
      this.map.addListener("dragstart", this.handleMapDrag);
      this.map.addListener("dragend", this.getCurrentDrag);
      // Prevent Ctrl+scroll from zooming the map
      this.map.addListener("wheel", (e) => {
        if (e.ctrlKey) {
          e.preventDefault();
        }
      });
      // Check map bounds in specific scenarios after a timeout
      if (
        this.selectCity &&
        this.selectCuisine.length &&
        Object.keys(this.setCenterLocation).length
      ) {
        setTimeout(this.checkMapBounds, 1000);
      }
    },
    loadPartnerOverlayFunc(product) {
      loadPartnerOverlay(product, this.context)
    },
    addMarkersOnMap(lat, lng, title, icon, slug, isRestaurant = false) {

      let iconScaledSize = "";
      if (isRestaurant) {
        iconScaledSize = new google.maps.Size(35, 35);
      }
      else {
        iconScaledSize = new google.maps.Size(50, 50);
      }
      // Create a marker for the location
      const marker = new google.maps.Marker({
        position: {
          lat: lat,
          lng: lng,
        },
        map: this.map,
        title: title,
        label: {
          text: title,
          color: 'black',
          fontSize: '12px',
          fontWeight: 'bold',
          bottom: '0',
          x: '200',
          y: '100'
        },
        icon: { url: icon, labelOrigin: new google.maps.Point(30, 55), scaledSize: iconScaledSize }, // Custom marker icon
        slug: slug
      });
      return marker;
    },
    // Asynchronous function to fetch map data by a specified title
    async getAllApiDataByTitle(name) {
      // If a title is provided, reset the map's center and zoom level
      if (name) {
        this.center = {
          lat: parseFloat(config.centerLat),
          lng: parseFloat(config.centerLng),
          label: config.centerLabel,
        };
        this.zoom = config.defaultZoom;
      }
      try {
        // Initialize variables
        this.mapsData = [];
        this.loading = true;
        let params = {};
        // Set the 'title' parameter if a name is provided
        if (name !== "" && name !== null) {
          params.title = name;
        }
        // Fetch map data using Axios
        let mapsData = await axios.get(this.getApiForTitle, {
          params: params,
        });

        // Process and filter the fetched data
        this.mapsData = mapsData.data
          .map((itm) => {
            let result = this.getLatLng(itm.product.meta_data);
            if (itm.product.child.length) {
              itm.product["childData"] = itm.product.child
                .map((data) => {
                  let latlng = this.getLatLng(data.meta_data);
                  if (latlng.lat && latlng.lng) {
                    data["position"] = latlng;
                    return data;
                  }
                })
                .filter((value) => value);
            }

            if (result.lat && result.lng) {
              itm["position"] = result;
            }
            return itm;
          })
          .filter((value) => value);
        this.mapsItems = this.mapsData;

        // Load Google Maps and initialize the map
        if (!window.google || !window.google.maps) {
          this.loadGoogleMaps()
            .then(() => this.initMap())
            .catch((error) => {
              console.error("Error loading Google Maps:", error);
            });
        } else {
          this.initMap(); // Your map initialization code
        }
        this.loading = false; // Mark loading as complete
      } catch (e) {
        console.log(e);
      }
    },
    decodeHtmlEntities(text) {
      const doc = new DOMParser().parseFromString(text, "text/html");
      return doc.body.textContent;
    },
    // Function to handle the current zoom level of the map
    getCurrentZoom() {
      if (this.isMapDragging || this.outerLocations) {
        // Map is currently being dragged, do nothing or perform specific actions
        return true;
      }

      this.ignoreCity = false;
      this.zoomChanged = true;
      this.locationFilter = null;

      this.center = {
        lat: this.map.getCenter().lat(),
        lng: this.map.getCenter().lng(),
        label: this.selectCity,
      };
      this.zoom = this.map.getZoom();
      let getCenterBounds = this.map.getBounds();
      this.centerNeLat = getCenterBounds.getNorthEast().lat();
      this.centerSwLat = getCenterBounds.getSouthWest().lat();
      this.centerNeLng = getCenterBounds.getNorthEast().lng();
      this.centerSwLng = getCenterBounds.getSouthWest().lng();
      // }
      this.getAllApiDataByFilter(config.defaultRadius);
      this.zoomChanged = false;
    },
    // Function to handle map drag
    handleMapDrag() {
      // Set the flag to indicate that the map is being dragged
      this.isMapDragging = true;
    },
    // Function to handle the current zoom level of the map
    getCurrentDrag() {
      this.center = {
        lat: this.map.getCenter().lat(),
        lng: this.map.getCenter().lng(),
        label: config.centerLabel,
      };
      if (this.selectCity) {
        this.ignoreCity = true;
      }
      this.zoom = this.map.getZoom();
      let getCenterBounds = this.map.getBounds();
      this.centerNeLat = getCenterBounds.getNorthEast().lat();
      this.centerSwLat = getCenterBounds.getSouthWest().lat();
      this.centerNeLng = getCenterBounds.getNorthEast().lng();
      this.centerSwLng = getCenterBounds.getSouthWest().lng();
      // Fetch and display data based on the new center and zoom level
      this.getAllApiDataByFilter(config.defaultRadius);
      this.ignoreCity = false;
      // Return true to indicate that the map bounds were adjusted
      return true;
    },
    // Asynchronous function to check and update map bounds
    async checkMapBounds() {
      // Get the bounds (bounding box) of the current map view
      var bounds = this.map.getBounds();
      // Get the corner points (northeast and southwest)
      var ne = bounds.getNorthEast();
      var sw = bounds.getSouthWest();
      var nes = new google.maps.LatLng(ne.lat(), ne.lng());
      var sws = new google.maps.LatLng(sw.lat(), sw.lng());
      var checkBounds = new google.maps.LatLngBounds(sws, nes);

      // Initialize loading and clear existing map items
      this.loading = true;
      this.mapsItems = [];
      // Iterate through each item in the mapsData array
      this.mapsData.map(async (item) => {
        if (item.position) {
          // Create a LatLng object for the item's position
          var markerLatLng = new google.maps.LatLng(
            item.position.lat,
            item.position.lng
          );
          // Check if the marker is within the current map bounds
          var isMarkerWithinBounds = checkBounds.contains(markerLatLng);

          if (isMarkerWithinBounds) {
            // Add the item to the mapsItems array if it's within bounds
            this.mapsItems.push(item);
          }
        }
        // Check if the item has child data
        if (item.product.childData !== undefined) {
          item.product.childData.map(async (itm) => {
            if (itm.position) {
              // Create a LatLng object for the child item's position
              var childmarkerLatLng = new google.maps.LatLng(
                itm.position.lat,
                itm.position.lng
              );
              // Check if the child marker is within the current map bounds
              var isChildMarkerWithinBounds =
                checkBounds.contains(childmarkerLatLng);

              if (isChildMarkerWithinBounds) {
                // Add the parent item to the mapsItems array if it's within bounds
                if (!this.mapsItems.includes(item)) {
                  this.mapsItems.push(item);
                }
              }
            }
          });
        }
      });
      // Disable loading if the checkbox is not enabled
      this.loading = false;
    },
    // Function to force a rerender of a component
    async forceRerender() {
      // Set a flag to hide the component
      this.renderComponent = false;
      // Wait for the next tick of the Vue lifecycle
      await this.$nextTick();
      // Set the flag to show the component again
      this.renderComponent = true;
    },
    // Function to force a rerender of a second component
    async forceRerenderSecond() {
      // Set a flag to hide the second component
      this.renderComponentSecond = false;
      // Wait for the next tick of the Vue lifecycle
      await this.$nextTick();
      // Set the flag to show the second component again
      this.renderComponentSecond = true;
    },
    // Function to reset filters and map settings
    resetFilters() {
      // Reset checkbox and selected city
      this.outerLocations = false;
      this.selectCity = null;
      this.locationFilter = null;
      // Remove the "selected" class from all cuisine items
      this.cuisineItems.forEach(item => {
        item.selected = false;
      });
      // Clear selected cuisine and fetch data based on filters
      this.selectCuisine = [];
      if (this.viewType != 'list') {
        this.center = {
          lat: parseFloat(config.centerLat),
          lng: parseFloat(config.centerLng),
          label: config.centerLabel,
        };
        this.zoom = config.defaultZoom;
        const newCenter = new google.maps.LatLng(config.centerLat, config.centerLng); // Replace with your new coordinates
        // Set the new center and zoom
        this.map.setCenter(newCenter);
        this.map.setZoom(this.zoom);
      }
      else {
        this.defaultCenterNeswBounds();
        this.getAllApiDataByFilter(0, true);
      }
    },
    // Function to update the view between list view and map view
    updateView(value) {
      // Get elements by class name
      let elements = document.getElementsByClassName("pnel_list");
      let element2 = document.getElementsByClassName("pnel_map");
      let rst_btn = document.getElementsByClassName("pnel_view_btn");
      // Toggle classes and update the view button text
      if (value) {
        elements[0].classList.add("pnel_toogle_class");
        element2[0].classList.remove("pnel_toogle_class");
        element2[0].classList.remove("d-none");
        rst_btn[0].innerHTML = "List View";
      } else {
        elements[0].classList.remove("pnel_toogle_class");
        elements[0].classList.remove("d-none");
        element2[0].classList.add("pnel_toogle_class");
        rst_btn[0].innerHTML = "Map View";
      }
      // Update the 'view' state
      this.view = value;
      this.viewButtonClicked = true
    },
    // Function to handle resizing of the view
    onResize() {
      requestAnimationFrame(() => {
        this.divHeight = this.$refs.infoBox.clientHeight;
        // Get elements by class name
        let elements = document.getElementsByClassName("pnel_list");
        let element2 = document.getElementsByClassName("pnel_map");
        let rst_btn = document.getElementsByClassName("pnel_view_btn");
        let buttonMain = document.getElementsByClassName("pnel_switch_btn_main");
        if (!this.viewButtonClicked && parseFloat(window.innerWidth) <= 959.98) {
          this.isMobile = true;
          if (this.viewTypeMobData == 'map|list' || this.viewTypeMobData == 'list|map') {
            buttonMain[0].classList.remove("d-none");
            buttonMain[0].classList.add("d-block");
            buttonMain[0].classList.add("d-md-none");
          }
          else {
            buttonMain[0].classList.remove("d-block");
            buttonMain[0].classList.remove("d-md-none");
            buttonMain[0].classList.add("d-none");
          }

          if (this.viewType == 'split' && this.viewTypeMob == 'map') {
            elements[0].classList.add("pnel_toogle_class");
            element2[0].classList.remove("pnel_toogle_class");
            rst_btn[0].innerHTML = "List View";
            this.view = true
          } else if(this.viewType == 'split' && this.viewTypeMob == 'list') {
            elements[0].classList.remove("pnel_toogle_class");
            element2[0].classList.add("pnel_toogle_class");
            rst_btn[0].innerHTML = "Map View";
            this.view = false
          }
          this.viewButtonClicked = false
        }
        else{
          this.isMobile = false;
        }
      });
    },
    // Function to handle scrolling behavior
    onScroll(e) {
      if (parseFloat(this.windowDivWidth) <= 959.98) {
        this.isMobile = true;
        // Get the current scroll position
        var windowTop = e.target.documentElement.scrollTop;
        let btn = document.getElementsByClassName("pnel_switch_btn_main");
        // Add or remove a class based on the scroll position
        if (parseFloat(windowTop) + 500 >= parseFloat(this.divHeight)) {
          btn[0].classList.add("pnel_view_btn_position");
        } else {
          btn[0].classList.remove("pnel_view_btn_position");
        }
      }
    },
  },
  mounted() {
    // Get the width of the window's screen
    this.windowDivWidth = window.screen.width;
    // Create a ResizeObserver to watch for changes in the 'infoBox' element's size
    this.ro = new ResizeObserver(this.onResize);
    this.ro.observe(this.$refs.infoBox);
    // Add a scroll event listener to the window
    window.addEventListener("scroll", this.onScroll);

    // Extract and set initial filter data from 'filterData' (if available)
    let getFilterData = typeof filterData === "undefined" ? "" : filterData;
    let getPluginImages = typeof pnelPluginImages === "undefined" ? "" : pnelPluginImages;
    if (getPluginImages) {
      this.cuisineIcons = getPluginImages.cuisineIcons;
      this.defaultResturantImage = getPluginImages.defaultRestaurantImage
    }
    if (getFilterData.showCuisineFilter != null && getFilterData.showCuisineFilter != "" && getFilterData.showCuisineFilter == "yes") {
      this.showCuisinesFilter = true;
    }
    if (getFilterData.showLocationFilter != null && getFilterData.showLocationFilter != "" && getFilterData.showLocationFilter == "yes") {
      this.showCityFilter = true;
    }
    if (getFilterData.cuisines != null && getFilterData.cuisines != "") {
      this.selectCuisine = getFilterData.cuisines.split(",");
    }
    if (getFilterData.location != null && getFilterData.location != "") {
      this.selectCity = getFilterData.location;
      this.locationFilter = getFilterData.location;
    }
    if (getFilterData.zoom != null && getFilterData.zoom != "") {
      this.zoomByShortcode = getFilterData.zoom;
    }
    if (getFilterData.view != null && getFilterData.view != "") {
      this.viewType = getFilterData.view;
    }

    if (getFilterData.viewMobile != null && getFilterData.viewMobile != "") {
      this.viewTypeMobData = getFilterData.viewMobile;
      this.viewTypeMob = this.viewTypeMobData.split('|')[0];
    }
    if (getFilterData.context != null && getFilterData.context != "") {
      this.context = getFilterData.context;
    } else {
      this.context = 'redemption';
    }
    if (
      getFilterData.allPostsByFilter !== "" &&
      getFilterData.allPostsByFilter !== undefined
    ) {
      this.getApiForFiltersData = getFilterData.allPostsByFilter;
    } else {
      this.getApiForFiltersData = config.allPostsByFilter;
    }
    if (
      getFilterData.allPostByTitle !== "" &&
      getFilterData.allPostByTitle !== undefined
    ) {
      this.getApiForTitle = getFilterData.allPostByTitle;
    } else {
      this.getApiForTitle = config.allPostByTitle;
    }
    if (
      getFilterData.getPostJson !== "" &&
      getFilterData.getPostJson !== undefined
    ) {
      this.getApiForJsonData = getFilterData.getPostJson;
    } else {
      this.getApiForJsonData = config.getPostJson;
    }

    if (
      getFilterData.getCuisinesList !== "" &&
      getFilterData.getCuisinesList !== undefined
    ) {
      this.getCuisinesList = getFilterData.getCuisinesList;
    } else {
      this.getCuisinesList = config.getCuisinesList;
    }

    // if (!this.view && parseFloat(this.windowDivWidth) <= 959.98) {
    //   this.viewType = this.viewTypeMob
    // }else{
    //   this.viewType = this.viewTypeDesk;
    // }
    this.getCuisinesApiData();
    this.getLocationsApiData();
    this.getAllApiDataByFilter();
  },
  beforeDestroy() {
    if (this.ro) {
      this.ro.disconnect();
      this.ro = null; // Set the ResizeObserver instance to null to clean it up
    }
    // Remove the scroll event listener from the window
    window.removeEventListener("scroll", this.onScroll);
  },
  components: {},
};
</script>
<style>
html {
  overflow: auto !important;
}

:root {
  --pnel_loaderSize: 10px;
  --pnel_loaderScale: 2.5em;
  --pnel_loaderAnimation: 2s;
  --pnel_loaderbg: #ccc;
}

.pnel-location-filter {
  max-width: 750px;

}

.pnel_list::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
}

.pnel-cuisine {
  justify-content: center;
  align-items: center;
  cursor: pointer;

}

.pnel_custom_autocomplete {
  width: calc(100% - 155px);
}

.pnel-cuisine img {
  width: 40px;
  opacity: .4;
}

.pnel-cuisine.selected {
  border-bottom: 2px solid #000;
}

.pnel-cuisine.selected img {
  width: 40px;
  opacity: 1;
}

.pnel-cuisine .v-list-item-title {
  font-size: 12px;
  margin-bottom: 2px;
}

.pnel_list::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

.pnel_list::-webkit-scrollbar-thumb {
  background-color: #f98000;
  outline: 1px solid #f98000;
  border-radius: 10px;
}

.pnel_top_section {
  flex-shrink: 0;
  flex-grow: 0;
}

.pnel_mainscroll {
  flex-shrink: 1;
  flex-grow: 1;
  overflow-y: auto;
}

.pnel_custom_image_width {
  object-fit: cover;
  height: 300px;
}

.pnel_object_info {
  position: absolute;
  height: auto;
  bottom: 0;
  left: 0;
  z-index: 11;
  color: #fff;
  line-height: 1.25;
  font-size: 1.4rem;
  background: -webkit-gradient(linear,
      left top,
      left bottom,
      color-stop(20%, transparent),
      to(#000000));
  background: linear-gradient(to bottom, transparent 20%, #000000 100%);
}

.pnel_city_restaurant {
  background: #002a43;
  color: #fff;
  right: 10px;
  top: 10px;
  font-size: 13px;
}

.pnel_distance {
  background: #002a43;
  color: #fff;
  left: 10px;
  top: 10px;
  font-size: 13px;
}

.pnel_auto-complete {
  width: 100%;
  background: transparent;
}

.pnel_auto_scroll .v-field__input {
  flex-wrap: nowrap !important;
  overflow-x: auto !important;
}

.pnel_auto_scroll input[type="text"] {
  padding: 0px !important;
}

.v-input__details {
  display: none !important;
}

.pnel_reset_btn {
  background-color: #f98000 !important;
  border-color: #f98000 !important;
  height: 54px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  line-height: 54px !important;
  text-align: center !important;
  color: #fff !important;
}

.pnel_switch_btn_main {
  bottom: 20px;
  left: 0;
  position: fixed;
}

.pnel_switch_btn_main.pnel_view_btn_position {
  position: unset;
}

.pnel_custom_autocomplete .v-input__control {
  height: 74px;
}

.pnel_custom_autocomplete input[type="text"] {
  background: transparent;
  border: transparent;
  font-size: 20px !important;
}

.pnel_custom_autocomplete .v-field__outline::before {
  display: none !important;
}

.pnel_custom_autocomplete .v-autocomplete .v-field.v-field,
.pnel_custom_autocomplete .v-combobox .v-field.v-field {
  -webkit-box-shadow: 0px 0px 12px 5px rgba(0, 0, 0, 0.05);
  box-shadow: 0px 0px 12px 5px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
}

.pnel_lightBg {
  background: #f3f3f3;
  color: #303030;
}

.pnel_custom_autocomplete .v-field__overlay {
  background: #fff !important;
  opacity: 1 !important;
}

.pnel_custom_autocomplete .v-autocomplete .v-field.v-field {
  background: transparent;
  border: transparent;
}

.pnel_custom_autocomplete .v-field__append-inner {
  display: none;
}

.pnel_custom_progress_loader {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
}

.pnel_custom_progress_loader::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.75);
  z-index: -1;
}

.pnel_custom_progress_loader p {
  color: #fff;
}

.pnel_combobox {
  background-color: #fff !important;
  transition: all ease-in-out 200ms;
}

.pnel_combobox:hover {
  background-color: #f6f6f6 !important;
  transition: all ease-in-out 200ms;
}

.pnel-active-item {
  background-color: #f6f6f6 !important;
  /* Highlight the active item */
}

.pnel_loading_animation {
  overflow: hidden;
  background: #d0d0d0;
}

.pnel_loading_animation_error {
  overflow: hidden;
  background: #ff0000;
  font-size: 15px;
  font-weight: 800;
  box-shadow: 0 0 5px rgba(0, 0, 0, .15);
  width: auto;
  max-width: 100%;
}

.pnel_custom_width {
  width: 300px;
  height: 330px;
}

.pnel_loading_animation::before {
  content: "";
  display: block;
  height: 100%;
  width: 100%;
  animation: skeleton 1s infinite;
  background: linear-gradient(to right, transparent, #d9d9d9, transparent);
}


@keyframes skeleton {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(100%);
  }
}

.pnel_custom_loader {
  z-index: 1;
}

.pnel_loader {
  color: var(--color1);
  font-size: var(--pnel_loaderSize);
  position: relative;
  text-indent: -9999em;
  transform: translate(calc((var(--pnel_loaderScale) + 1em) * -1),
      calc(var(--pnel_loaderScale) * -1)) translateZ(0);
  border-radius: 50%;
  width: var(--pnel_loaderScale);
  height: var(--pnel_loaderScale);
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation: pnel_loader var(--pnel_loaderAnimation) infinite ease-in-out;
  animation: pnel_loader var(--pnel_loaderAnimation) infinite ease-in-out;
}

.pnel_loader::after,
.pnel_loader::before {
  content: "";
  position: absolute;
  top: 0;
  border-radius: 50%;
  width: var(--pnel_loaderScale);
  height: var(--pnel_loaderScale);
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation: pnel_loader var(--pnel_loaderAnimation) infinite ease-in-out;
  animation: pnel_loader var(--pnel_loaderAnimation) infinite ease-in-out;
}

.pnel_loader::after {
  -webkit-animation-delay: calc(var(--pnel_loaderAnimation) / 10);
  animation-delay: calc(var(--pnel_loaderAnimation) / 10);
  inset-inline-start: calc(var(--pnel_loaderScale) + 1em);
}

.pnel_loader::before {
  inset-inline-start: calc((var(--pnel_loaderScale) * 2) + 2em);
  -webkit-animation-delay: calc(var(--pnel_loaderAnimation) / 5);
  animation-delay: calc(var(--pnel_loaderAnimation) / 5);
}

.custom-text-wrap {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 12em;
  /* Adjust the max-width as needed */
}

.v-card .v-card-title p {
  font-size: 2.2rem !important;
  font-weight: bold;
  white-space: normal;
}

.v-card .v-card-text p {
  font-size: 1.3rem !important;
  line-height: 1.5rem !important;
}

.autocomplete-suggestions~div {
  font-size: 16px;
}

.custom-v-checkbox .v-input--selection-controls__input {
  opacity: 1;
  /* Set opacity to 1 to make the checkbox visible */
}

.custom-v-checkbox .v-input--selection-controls__ripple {
  display: none;
  /* Hide the ripple effect (optional) */
}

.pnel_filters {
  padding-right: 12px !important;
}

.pnel_map button.gm-ui-hover-effect:active,
.pnel_map button.gm-ui-hover-effect:focus,
.pnel_map button.gm-ui-hover-effect:visited {
  border: 0px !important;
  outline: none;
}

@-webkit-keyframes pnel_loader {

  0%,
  80%,
  100% {
    box-shadow: 0 var(--pnel_loaderScale) 0 calc((var(--pnel_loaderScale) - 1em) * -1);
  }

  40% {
    box-shadow: 0 var(--pnel_loaderScale) 0 0 var(--pnel_loaderbg);
  }
}

@keyframes pnel_loader {

  0%,
  80%,
  100% {
    box-shadow: 0 var(--pnel_loaderScale) 0 calc((var(--pnel_loaderScale) - 1em) * -1);
  }

  40% {
    box-shadow: 0 var(--pnel_loaderScale) 0 0 var(--pnel_loaderbg);
  }
}

@media screen and (max-width: 959.98px) {
  .pnel_custom_autocomplete {
    width: 100%;
  }

  .pnel_toogle_class {
    display: none;
  }

  .pnel_reset_btn {
    height: 30px !important;
    line-height: 30px !important;
  }

  .pnel_filters {
    padding-right: 0px !important;
  }

  .pnel_list::-webkit-scrollbar {
    display: none;
  }

  .pnel_mainscroll {
    flex-direction: column;
  }
}
</style>
